import React from 'react';

import ContractTable from '../Table';

import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ContractTable />
    </div>
  );
};
